import get from 'lodash.get';

import createDeepEqualSelector from 'utils/reselect/typescript/createDeepEqualSelector';
import { selectSprayedEntitiesByDate } from 'services/sprayedEntitiesByDate/selectors';
import { AppState } from 'services/types';
import { SprayEventEntityId } from 'services/sprayEvents/types';
import { Props } from './index';

const selectEntityId = (state: AppState, props: Props): SprayEventEntityId =>
    props.entityId;

const selectEntityHasBeenSprayedAlready = createDeepEqualSelector(
    selectSprayedEntitiesByDate,
    selectEntityId,
    (sprayedEntities, entityId) => Boolean(get(sprayedEntities, entityId))
);

const makeSelectEntityHasBeenSprayedAlready = (): typeof selectEntityHasBeenSprayedAlready =>
    selectEntityHasBeenSprayedAlready;

export { selectEntityId, makeSelectEntityHasBeenSprayedAlready };
